import React from "react"

class RoomTypePriceBuilderForm extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		var days_of_week = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
		var days = days_of_week.map((day_of_week) => {
			return this.renderDayOfWeek(day_of_week);
		});

		return (
			<div>
        {this.props.nested ? <input type="hidden" name={this.renderFieldName('id')} value={this.props.id} onChange={this.props.onChange} /> : null}

				<div className="row seven-cols">
					{days}
			  </div>

        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('max_guests_allowed')} <span className="ss-help help" title={I18n.t('max_guests_allowed_helper_text')}></span></label>
              {
                this.props.read_only
                ?
                <div>{this.props.max_guests_allowed}</div>
                :
                <div>
                  <NumberInput min={0} name={this.renderFieldName("max_guests_allowed")} className={this.renderFieldClasses('max_guests_allowed', "form-control")} onChange={this.props.onChange} value={this.props.max_guests_allowed} />
                  {this.renderFieldErrors('max_guests_allowed')}
                </div>
              }
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('guests_included')} <span className="ss-help help" title={I18n.t('guests_included_helper_text')}></span></label>
              {
                this.props.read_only
                ?
                <div>{this.props.guests_included}</div>
                :
                <div>
                  <NumberInput min={0} name={this.renderFieldName("guests_included")} className={this.renderFieldClasses('guests_included', "form-control")} onChange={this.props.onChange} value={this.props.guests_included} />
                  {this.renderFieldErrors('guests_included')}
                </div>
              }
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('additional_guest_amount')} <span className="ss-help help" title={I18n.t('additional_guest_price_helper_text')}></span></label>
              {
                this.props.read_only
                ?
                <div>${this.props.additional_guest_amount ? this.props.additional_guest_amount / 100 : '0.00'}</div>
                :
                <div>
                  <div className={this.renderFieldClasses(name, "input-group input-group-currency")}>
                    <div className="input-group-addon">{I18n.t('number.currency.format.unit')}</div>
                    <CurrencyInput className={this.renderFieldClasses('additional_guest_amount', "form-control")} name={this.renderFieldName('additional_guest_amount')} onChange={this.props.onChange} value={this.props.additional_guest_amount} onChangeEventType={true} />
                  </div>
                  {this.renderFieldErrors('additional_guest_amount')}
                </div>
              }
            </div>
          </div>

          {
            this.props.nested
            ?
            null
            :
            <div className="col-md-3">
              <div className="form-group">
                <label>{I18n.t('room_type')} <span className="ss-help help" title={I18n.t('room_type_prices_room_type_helper_text')}></span></label>
                {
                  this.props.read_only
                  ?
                  <div>{this.props.room_type.name}</div>
                  :
                  <RoomTypeSelect room_type={this.props.room_type} onChange={this.props.onChangeRoomType} allowClear={true} excludedRoomTypeIds={this.props.room_type_ids_already_in_use} />
                }
              </div>
            </div>
          }
        </div>
			</div>
		);
	}

	renderDayOfWeek(day_of_week) {
		var name = day_of_week + '_amount';

		return (
	    <div className="col-md-1" key={day_of_week}>
	    	<div className="form-group">
	    		<label>{I18n.t(day_of_week)}</label>
	    		{
	    			this.props.read_only 
	    			?
	    			<div>${this.props[name] ? this.props[name] / 100 : '0.00'}</div>
	    			:
	    			<div>
			    		<div className={this.renderFieldClasses(name, "input-group input-group-currency")}>
		            <div className="input-group-addon">{I18n.t('number.currency.format.unit')}</div>
			    			<CurrencyInput className="form-control" name={this.renderFieldName(name)} onChange={this.props.onChange} value={this.props[name]} onChangeEventType={true} nested={true} />
			    		</div>
              {this.renderFieldErrors(name)}
	    			</div>
	    		}
	    	</div>
	    </div>
		);
	}

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map( (error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field, classnames) {
    var classname = classnames || 'form-control';
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  } 

  renderFieldName(field) {
    if (this.props.nested) {
      return 'room_type_price_attributes[' + field + ']';
    } else {
      return field;
    }
  }

};

export default RoomTypePriceBuilderForm